import React from 'react'
import styled from 'styled-components'

const StyledTable = styled.table`
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;

    th,
    td {
        padding: 0.75rem;
        vertical-align: top;
        border-top: 1px solid #dee2e6;
    }

    thead th {
        vertical-align: bottom;
        border-bottom: 2px solid #dee2e6;
    }
`

const Table = ({ children, ...props }) => {
    return <StyledTable {...props}>{children}</StyledTable>
}

export default Table
